import { createNewEntitySlice } from 'containers/App/modules/entities/entities.utils';
import { createSelector } from '@reduxjs/toolkit';
import { ENTITIES_STATE_KEY, ENTITY_TYPES } from 'containers/App/modules/entities/entities.constants';
import _ from 'lodash';

export const STATE_KEY = ENTITY_TYPES.SECURITY_VERSION_HISTORIES;

const securityVersionHistoryEntitySlice = createNewEntitySlice({
    name: STATE_KEY,
    extraAsyncActions: [],
});

const { reducer, actions, selectors } = securityVersionHistoryEntitySlice;
const {
    fetchAll: fetchSecurityVersionHistories,
    fetchAllPending: fetchSecurityVersionHistoriesPending,
    fetchAllSuccess: fetchSecurityVersionHistoriesSuccess,
    fetchAllFailure: fetchSecurityVersionHistoriesFailure,
} = actions;

export const securityVersionHistoryEntityActions = {
    fetchSecurityVersionHistories,
    fetchSecurityVersionHistoriesPending,
    fetchSecurityVersionHistoriesSuccess,
    fetchSecurityVersionHistoriesFailure,
};

const getEntitiesState = state => state[ENTITIES_STATE_KEY] || {};

const getState = createSelector(
    getEntitiesState,
    state => _.get(state, STATE_KEY)
);

const {
    selectAll: selectSecurityVersionHistories,
    selectFetchAllPending: selectSecurityVersionHistoriesPending,
} = selectors;


export const securityVersionHistoryEntitySelectors = {
    selectSecurityVersionHistories,
    selectSecurityVersionHistoriesPending,
};

export default reducer;